import { AutofillSingleWallRules } from './SingleWallRulesSet';

export const ruleSetSingleWallSliding = {
  0: [],
  500: [],
  750: [],
  1000: [],
  1250: [],
  1500: [750, 750],
  1750: [],
  2000: [1000, 1000],
  2250: [],
  2500: [],
  2750: [],
  3000: [750, 750, 750, 750],
  3250: [],
  3500: [1000, 1000, 750, 750],
  3750: [],
  4000: [1000, 1000, 1000, 1000]
} as AutofillSingleWallRules;
